import { type Voicemail } from '@reliance/types/models/Voicemail';
import { type AuthToken } from '@reliance/types/models/Auth';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';

export const voicemail = (siteApi: ApiService, getToken: () => AuthToken) => ({
  get: (id) => {
    return siteApi.get(`/voicemail/${id}`);
  },
  index: (params = {}): Promise<PaginatedResponse<Voicemail>> => {
    return siteApi.get('/voicemail', { params });
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/voicemail.pdf', {
      ...params,
      token: getToken().accessToken,
    });
  },
});
